import React from 'react'
import withContext from "../withContext";
import Formsincheckout from './formsincheckout';

class Precheckout extends React.Component {
  componentDidMount(){
    document.body.style.paddingTop = "6em";
    window.scrollTo(0, 0);
  }
  componentWillUnmount(){
    document.body.style.paddingTop = "0";
  }
  
  render(){
    


  return (
    <>
    <Formsincheckout />
    </>
  );
  }
};

export default withContext(Precheckout);